import { useMutation } from '@tanstack/react-query';
import { confirmPickupFromConsumer } from '../services';

const useConfirmPickupFromConsumer = () => {
  return useMutation({
    mutationKey: ['confirmPickupFromConsumer'],
    mutationFn: async ({ idOrder, payload }) =>
      await confirmPickupFromConsumer({ idOrder, payload }),
    retry: 3,
  });
};

export default useConfirmPickupFromConsumer;
